const KEY_SCOPE_OPTIONS = [
    { value: 'lists', label: 'IP Lists', description: 'Manage IP lists.' },
    { value: 'grafana', label: 'Grafana', description: 'Access Grafana proxy APIs.' },
    { value: 'ddosguard', label: 'DDoS Guard', description: 'Access DDoS Guard endpoints.' },
    { value: 'netc', label: 'NetC', description: 'Access NetC agent endpoints.' },
    { value: 'logs:write', label: 'Log ingestion', description: 'Send logs to this organization tenant.' },
    {
        value: 'metrics:read',
        label: 'Telemetry metrics',
        description: 'Query organization metrics through the external telemetry API.'
    },
    {
        value: 'logs:read',
        label: 'Telemetry logs',
        description: 'Search organization logs through the external telemetry API.'
    }
];

export {
    KEY_SCOPE_OPTIONS
};
